import { Injectable } from "@angular/core";
import { AuthenticationService } from "@auth/authentication.service";
import { redirectTo, showToastr } from "@shared/common";
import { TokenService } from "./token.service";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenService: TokenService,
    private toastr: ToastrService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.currentUserValue;

    try {
      if (
        !currentUser ||
        this.tokenService.isTokenExpired(currentUser.AccessToken)
      ) {
        return true;
      }
    } catch (error) {
      return true;
    }

    try {
      this.router.navigate([redirectTo(currentUser as any)]);
    } catch (error) {
      showToastr(this.toastr, error, "error");

      setTimeout(() => {
        this.authenticationService.signout();
      }, 500);
    }
  }
}
